"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETS_SPECIES_TO_REPORT_CATEGORY = exports.MPI_FOREST_ID_TO_ETS_SPECIES = exports.MPI_TO_ETS_SPECIES = void 0;
exports.MPI_TO_ETS_SPECIES = {
    'Douglas fir': 'douglas_fir',
    'Other Exotic Hardwoods': 'exotic_hardwood',
    'Other Exotic Softwoods': 'exotic_softwood',
    Indigenous: 'indigenous',
    'Pinus radiata': 'pinus_radiata',
};
exports.MPI_FOREST_ID_TO_ETS_SPECIES = {
    1: 'douglas_fir',
    2: 'exotic_hardwood',
    3: 'exotic_softwood',
    4: 'indigenous',
    6: 'pinus_radiata',
};
exports.ETS_SPECIES_TO_REPORT_CATEGORY = {
    douglas_fir: 'existing_exotic_ets_forest',
    exotic_hardwood: 'existing_exotic_ets_forest',
    exotic_softwood: 'existing_exotic_ets_forest',
    indigenous: 'existing_indigenous_ets_forest',
    radiata: 'existing_exotic_ets_forest',
    pinus_radiata: 'existing_exotic_ets_forest',
};
